import { userModuleAccessService } from "./services/user-module-access.service";

export function isTenantAdminRole(roleSlug: string | undefined): boolean {
  if (!roleSlug) return false;
  return (
    roleSlug === "TENANT_ADMIN" ||
    roleSlug === "PLATFORM_OWNER" ||
    roleSlug === "PLATFORM_ADMIN"
  );
}

export function resolveUserModuleGrants(
  tenantId: string,
  userId: string,
  roleSlug: string | undefined
): string[] | null {
  if (isTenantAdminRole(roleSlug)) return null;
  const grants = userModuleAccessService.listGrantedModuleIds(tenantId, userId);
  return grants.length > 0 ? grants : null;
}
